'use client';

import Link from '@/components/Link';
import styles from './notFound.module.scss';
import { QuestionMark } from '@goodneighbor/ui';

export default function NotFoundPage() {
  return (
    <main className={styles.notFound}>
      <QuestionMark className={styles.questionMark} />
      <h1 className={styles.header}>Page not found</h1>
      <h2 className={styles.description}>
        Sorry, the page you are looking for does not exist.
      </h2>
      <Link className={styles.ctaButton} asButton href="/">
        Return home
      </Link>
    </main>
  );
}
